import { useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import {
  AppointmentCompleteRequest,
  completeAppointment,
  getAppointment,
} from '@user/store/scheduling'
import { toast } from '@sales-center/components'
import { ICancelAppointmentProps } from '../typings'

export function useActions(props: ICancelAppointmentProps) {
  const { appointmentId, onClose, onCloseMain, entityId, entityType } = props

  const dispatch = useAppDispatch()

  const onSubmit = useCallback(
    async (model: AppointmentCompleteRequest) => {
      if (!appointmentId) {
        toast.error('Invalid data passed')
        return
      }

      const response = await dispatch(
        completeAppointment({
          appointmentId,
          requestInput: model,
          entityId,
          entityType,
        }),
      )

      if (completeAppointment.fulfilled.match(response)) {
        if (response.payload?.success) {
          toast.success('Appointment cancelled.')
          onClose()
          onCloseMain()

          if (appointmentId) {
            dispatch(
              getAppointment({
                entityId,
                entityType,
                appointmentId,
              }),
            )
          }
        } else {
          toast.error(
            response.payload?.message ?? 'Failed to cancel appointment.',
          )
        }
      } else {
        toast.error('Failed to cancel appointment.')
      }
    },
    [appointmentId, dispatch, entityId, entityType, onClose, onCloseMain],
  )

  return {
    onSubmit,
  }
}
